import { useEffect, useState } from 'react';
import { Card, Form, Button, Alert, Spinner, Row, Col } from 'react-bootstrap';
import { api } from '../api/client';

export default function AdminSettings() {
  const [settings, setSettings] = useState(null);
  const [f, setF] = useState({ commission_pct: '', teacher_registration_fee: '' });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState({ type: '', text: '' });

  const load = async () => {
    try {
      const s = await api.get('/admin/settings');
      setSettings(s);
      setF({
        commission_pct: String(s.commission_pct),
        teacher_registration_fee: String(s.teacher_registration_fee),
      });
    } catch (e) {
      setMsg({ type: 'danger', text: e.message });
    }
  };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.put('/admin/settings', {
        commission_pct: Number(f.commission_pct),
        teacher_registration_fee: Number(f.teacher_registration_fee),
      });
      setSettings(r);
      setMsg({ type: 'success', text: 'Settings updated.' });
    } catch (e2) {
      setMsg({ type: 'danger', text: e2.message });
    } finally {
      setBusy(false);
    }
  };

  if (!settings) return <div className="text-center py-5"><Spinner /></div>;

  return (
    <>
      <h3 className="mb-4">Platform Settings</h3>
      {msg.text && <Alert variant={msg.type} dismissible onClose={() => setMsg({ type: '', text: '' })}>{msg.text}</Alert>}
      <Card className="shadow-sm" style={{ maxWidth: 600 }}>
        <Card.Body>
          <Form onSubmit={save}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Commission %</Form.Label>
                  <Form.Control type="number" min={0} max={100} step="0.5" value={f.commission_pct} onChange={(e) => setF({ ...f, commission_pct: e.target.value })} required />
                  <Form.Text>Taken from each teacher's monthly fee at settlement.</Form.Text>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Teacher registration fee (₹)</Form.Label>
                  <Form.Control type="number" min={0} value={f.teacher_registration_fee} onChange={(e) => setF({ ...f, teacher_registration_fee: e.target.value })} required />
                  <Form.Text>One-time fee teachers pay before their profile goes live.</Form.Text>
                </Form.Group>
              </Col>
            </Row>
            <Button type="submit" disabled={busy}>{busy ? 'Saving...' : 'Save settings'}</Button>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
}
